var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotationMark = function SvgQuotationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 33,
    fill: "none",
    viewBox: "0 0 57 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20.882.096 3.944 6.528q-9.657 6.528-12.24 9.792 3.127.409 5.032 2.992 1.904 2.584 1.36 5.848-.544 3.128-3.264 5.44-2.585 2.175-5.984 2.176-4.216 0-6.8-3.264-2.448-3.4-1.768-8.024Q2.794 10.432 20.882.096m23.8 16.32q3.127.409 5.032 2.992t1.36 5.848q-.544 3.128-3.264 5.44-2.585 2.175-5.984 2.176-4.216 0-6.8-3.264-2.449-3.4-1.768-8.024Q34.89 10.432 52.978.096l3.944 6.528q-9.655 6.528-12.24 9.792"
  })));
};
export default SvgQuotationMark;